import { ExperimentType } from 'ha/modules/Experiments';

const Experiments: { [name: string]: ExperimentType } = {
  HA5972: {
    name: '[HA-5972] Cancellation Policies',
    variants: ['A', 'B', 'C'],
    weights: [33.34, 33.33, 33.33],
  },
  HA7595: {
    name: '[HA-7595] Commute time in focused countries',
    variants: ['A', 'B'],
    weights: [50, 50],
  },
  HA8438: {
    name: '[HA-8438] Update search date logic',
    variants: ['A', 'B'],
    weights: [50, 50],
  },

  /* Growth */
  GROWTH191: {
    name: '[GROWTH-191] Rent Radar Banner on LDP',
    variants: ['A', 'B'],
    weights: [50, 50],
  },
  GROWTH276: {
    name: '[GROWTH-276] Tenant deposit insurance',
    variants: ['A', 'B'],
    weights: [50, 50],
  },
  GROWTH486: {
    name: '[GROWTH-486] Content Card on search',
    variants: ['A', 'B'],
    weights: [50, 50],
  },
};

export default Experiments;
